/* =========================================================
	SUBMIT FORM
	Submits search form on select/dropdown change, but only
	for non-mobile (i.e. where the submit button is hidden)
========================================================= */

let sectionSearchForm = document.querySelector("#section-search");
let categoryOption = document.querySelector("#categoryOption");
let resourceTypeOption = document.querySelector("#resourceTypeOption");
let eventTypeOption = document.querySelector("#eventTypeOption");

function submitSearchForm() {
	sectionSearchForm.submit();
}

if(typeof(categoryOption) != 'undefined' && categoryOption != null) {
	categoryOption.addEventListener("change", submitSearchForm, false);
}

if(typeof(resourceTypeOption) != 'undefined' && resourceTypeOption != null) {
	resourceTypeOption.addEventListener("change", submitSearchForm, false);
}

if(typeof(eventTypeOption) != 'undefined' && eventTypeOption != null) {
	eventTypeOption.addEventListener("change", submitSearchForm, false);
}
